export const awsAmplifyConfig = {
    Auth: {
        region: process.env.REACT_APP_AWS_REGION,
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_USER_CLIENT_ID,
        // Enforce user authentication prior to accessing AWS resources
        mandatorySignIn: true,

        // Configuration for cookie storage
        // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
        cookieStorage: {
            // REQUIRED - Cookie domain (only required if cookieStorage is provided)
            domain: '.' + process.env.REACT_APP_DOMAIN,
            // Cookie expiration in days
            expires: 30,
            // ee: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
            sameSite: "lax",
            // Cookie secure flag - indicating the cookie transmission requires a secure protocol (https).
            secure: true
        },
        // Hosted UI configuration
        oauth: {
            domain: process.env.REACT_APP_DOMAIN?.replace(/\./g, '-') + '.auth.us-west-2.amazoncognito.com',
            scope: ['phone', 'email', 'profile', 'openid'],
            redirectSignIn: process.env.REACT_APP_OAUTH_REDIRECT_SIGNIN || 'https://' + process.env.REACT_APP_DOMAIN,
            redirectSignOut: process.env.REACT_APP_OAUTH_REDIRECT_SIGNOUT || 'https://' + process.env.REACT_APP_DOMAIN,
            responseType: 'code',
            socialProviders: ['google']
        }
    }
};

export const awsDevelopmentAmplifyConfig = {
    Auth: {
        region: process.env.REACT_APP_AWS_REGION,
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_USER_CLIENT_ID,
        // Enforce user authentication prior to accessing AWS resources
        mandatorySignIn: true,
        // Hosted UI configuration
        oauth: {
            domain: process.env.REACT_APP_DOMAIN?.replace(/\./g, '-') + '.auth.us-west-2.amazoncognito.com',
            scope: ['phone', 'email', 'profile', 'openid'],
            redirectSignIn: process.env.REACT_APP_OAUTH_REDIRECT_SIGNIN || 'https://' + process.env.REACT_APP_DOMAIN,
            redirectSignOut: process.env.REACT_APP_OAUTH_REDIRECT_SIGNOUT || 'https://' + process.env.REACT_APP_DOMAIN,
            responseType: 'code',
            socialProviders: ['google']
        }
    }
};
